/**
 * Banner 1051 — KUK home hero.
 * Slides are `metadata`; the white card over them is section level, so the copy
 * does not change as the carousel advances (which is what v1 does).
 */

export const BANNER_1051_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Carousel slides",
  },

  DEFAULT_ROW: {
    id: "1",
    image: "",
    alt_image: "KUK Online",
    mobile_image: "",
    mobile_alt_image: "KUK Online",
    priority: 1,
    status: true,
  },

  BANNER_FIELDS_CONFIG: [
    {
      fieldName: "slide_frequency",
      label: "Slide interval (ms)",
      value: 5000,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "5000",
      defaultValue: 5000,
    },
    {
      fieldName: "hero_section_height",
      label: "Desktop height (px)",
      value: 0,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "0",
      description:
        "0 keeps the reference's viewport-relative height (75vh, or 90vh on a short window). Below 768px it is always 60vh.",
      defaultValue: 0,
    },
    {
      fieldName: "title_1",
      label: "Eyebrow",
      value: "Welcome to",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Welcome to",
      defaultValue: "Welcome to",
    },
    {
      fieldName: "title_1_color",
      label: "Eyebrow colour",
      value: "#031F44",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#031F44",
    },
    {
      fieldName: "title",
      label: "University name",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Kurukshetra University",
      required: true,
      defaultValue: "",
    },
    {
      fieldName: "title_color",
      label: "University name colour",
      value: "#031F44",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#031F44",
    },
    {
      fieldName: "title_2",
      label: "Second line",
      value: "Online",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Online",
      defaultValue: "Online",
    },
    {
      fieldName: "title_2_color",
      label: "Second line colour",
      value: "#9F1C33",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#9F1C33",
    },
    {
      fieldName: "description",
      label: "Supporting line",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Where Future Leaders and Innovators Make Their Mark.",
      defaultValue: "",
    },
    {
      fieldName: "description_color",
      label: "Supporting line colour",
      value: "#031F44",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#031F44",
    },
    {
      fieldName: "background_color",
      label: "Card fill",
      value: "rgba(255, 255, 255, 0.9)",
      valueType: "string",
      filedType: "RGBA",
      placeholder: "rgba(255, 255, 255, 0.9)",
      description: "The panel the copy sits on, over the slide.",
      defaultValue: "rgba(255, 255, 255, 0.9)",
    },
    {
      fieldName: "carousel_color",
      label: "Prev / next arrow background",
      value: "rgba(0, 0, 0, 0.5)",
      valueType: "string",
      filedType: "RGBA",
      placeholder: "rgba(0, 0, 0, 0.5)",
      description: "Arrows show from 768px up and only with more than one slide.",
      defaultValue: "rgba(0, 0, 0, 0.5)",
    },
    {
      fieldName: "apply_now_show",
      label: "Show CTA button",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
    {
      fieldName: "apply_now_text",
      label: "CTA label",
      value: "Enroll Now",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enroll Now",
      defaultValue: "Enroll Now",
    },
    {
      fieldName: "apply_now_is_cta",
      label: "Is CTA (lead popup)",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "On = open lead capture popup instead of the CTA URL",
      defaultValue: true,
    },
    {
      fieldName: "apply_now_link",
      label: "CTA URL (used when Is CTA is off)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "/contact or https://…",
      defaultValue: "",
    },
    {
      fieldName: "button_color",
      label: "CTA background",
      value: "#9F1C33",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#9F1C33",
    },
    {
      fieldName: "apply_now_color",
      label: "CTA text colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "status",
      label: "Banner status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Slide background (desktop)",
      fieldName: "image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Desktop background image",
      defaultValue: "",
    },
    {
      header: "Background alt (desktop)",
      fieldName: "alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Slide background (mobile)",
      fieldName: "mobile_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Optional — uses the desktop image if empty",
      defaultValue: "",
    },
    {
      header: "Background alt (mobile)",
      fieldName: "mobile_alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],
};
